<template>
    <div class="el-table-container templateBox">
        <div class="query-form">
            <el-tabs v-model="searchForm.auitStatus" @tab-click="handleClick">
                <el-tab-pane v-for="item in pageTypeList" :key="item.name" :label="item.name"
                             :name="item.value"></el-tab-pane>
            </el-tabs>
        </div>
        <div class="query-form">
            <el-button v-if="hasPermission('collection:store:toExamine:through')"
                       @click="examineData(0)" size="small">审核通过
            </el-button>
            <el-button v-if="hasPermission('collection:store:toExamine:reject')"
                       @click="examineData(1)" size="small">审核驳回
            </el-button>
        </div>
        <el-form size="small" :inline="true" class="query-form" ref="searchForm" :model="searchForm"
                 @keyup.enter.native="refreshList(1)" @submit.native.prevent label-width="90px">
            <el-form-item label="入库原因" prop="inWarehouseCause">
                <el-select v-model="searchForm.inWarehouseCause" clearable placeholder="请选择入库原因">
                    <el-option
                        v-for="item in $dictUtils.getDictList('in_warehouse_cause')"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="入库日期" prop="outDataTime">
                <el-date-picker
                    v-model="searchForm.outDataTime"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
                <el-select v-model="searchForm.applicant" clearable placeholder="请选择申请人">
                    <el-option
                        v-for="item in applicantList"
                        :key="item.applicant"
                        :label="item.applicantName"
                        :value="item.applicant">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="this.searchForm.auitStatus != '0'" label="审核状态" prop="status">
                <el-select v-model="searchForm.status" clearable placeholder="请选择审核状态">
                    <el-option label="审核通过" value="2"></el-option>
                    <el-option label="审核驳回" value="3"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="refreshList(1)" size="small" icon="el-icon-search">查询</el-button>
                <el-button @click="reset()" size="small" icon="el-icon-refresh-right">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="tips">
            <el-link class="el-icon-info" type="primary" :underline="false"></el-link>
            已选择{{ dataListSelections.length }}项数据
        </div>
        <el-table
                :data="dataList"
                size="small" height="100%"
                class="table" ref="multipleTable" border
                @selection-change="selectionChangeHandle" row-key='id' v-loading="loading">
            <el-table-column type="selection" :reserve-selection='true' fixed/>
            <el-table-column type="index" label="序号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="inWarehouseCause" label="入库原因" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("in_warehouse_cause", row.inWarehouseCause, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="inWarehouseTime" label="预入库时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicant" label="申请人" show-overflow-tooltip></el-table-column>
            <el-table-column prop="applicantTime" label="申请时间" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" label="审批状态" show-overflow-tooltip>
                <template slot-scope="{row}">
                    <div>{{ $dictUtils.getDictLabel("collection_status", row.status, '') }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
            <el-table-column fixed="right" label="操作" min-width="150">
                <template slot-scope="{row,$index}">
                    <el-button v-if="hasPermission('collection:store:toExamine:view')" type="text" size="small"
                               @click="addData('view',row,$index)">详情
                    </el-button>
                    <el-button v-show="searchForm.status == 0" v-if="hasPermission('collection:store:toExamine:through')" type="text" size="small"
                               @click="examineData(0,row)">通过
                    </el-button>
                    <el-button v-show="searchForm.status == 0" v-if="hasPermission('collection:store:toExamine:reject')" type="text" size="small"
                               @click="examineData(1,row)">驳回
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="searchForm.current" :limit.sync="searchForm.size"
                    @pagination="refreshList"/>
        <detail-store ref="detailStore" @itemsChange="itemsChange"></detail-store>
        <set-toexamine ref="setToexamine" @refresh="refreshList('',1)"></set-toexamine>
    </div>
</template>

<script>

import SetToexamine from "@/views/modules/collection/outbound/setToexamine.vue";
import DetailStore from "@/views/modules/collection/store/detailStore.vue";

export default {
    name: "toExamine",
    components: {DetailStore, SetToexamine},
    data() {
        return {
            searchForm: {
                auitStatus: '0',
                status:'',
                inWarehouseCause: '',
                applicant: '',
                dataTime: [],
                inWarehouseStartTime: '',
                inWarehouseEndTime: '',
                current: 1,
                size: 20,
            },
            applicantList: [],
            pageTypeList: [
                {
                    name: '待审核',
                    value: '0',
                },
                {
                    name: '已审核',
                    value: '1',
                },
            ],

            loading: false,
            dataList: [],
            dataListSelections: [],
            total: 0,
            searchData: {},
            detailCurrt:0,
        }
    },

    mounted() {
        this.refreshList()
        this.getOthers()
    },

    methods: {
        // 获取数据列表 current查第几页数据
        refreshList(type, clearSelect) {
            if (type == 1) {
                this.searchForm.current = 1
            }
            if (clearSelect) {
                this.$refs.multipleTable.clearSelection()
            }
            this.loading = true
            this.searchData = JSON.parse(JSON.stringify(this.searchForm))
            if (this.searchData.auitStatus == '99') {
                this.searchData.auitStatus = ''
            }
            if (this.searchData.dataTime && this.searchData.dataTime.length) {
                this.searchData.inWarehouseStartTime = this.searchData.dataTime[0]
                this.searchData.inWarehouseEndTime = this.searchData.dataTime[1]
            } else {
                this.searchData.inWarehouseStartTime = ''
                this.searchData.inWarehouseEndTime = ''
            }
            this.$axios(this.api.collection.collectioninwarehouseRevdlist, this.searchData).then(data => {
                if (data && data.status) {
                    this.dataList = data.data.records
                    if (this.dataList.length == 0 && this.searchForm.current > 1) {
                        this.searchForm.current--
                        this.refreshList()
                    }
                    this.total = parseInt(data.data.total)
                    this.loading = false
                } else {
                    this.$message.error('查询失败')
                }
            })
            this.$axios(this.api.collection.revdTabCountInWarehouse).then(data => {
                if (data && data.status) {
                    this.pageTypeList = [
                        {
                            name: '待审核',
                            value: '0',
                        },
                        {
                            name: '已审核',
                            value: '1',
                        },
                    ]
                    this.pageTypeList[0].name += '(' + data.data.noHandle + ')'
                    this.pageTypeList[1].name += '(' + data.data.handle + ')'
                }
            })
        },

        // 重置
        reset() {
            this.$refs.searchForm.resetFields();
            this.refreshList(1, 1)
        },

        //获取其他信息
        getOthers() {
            this.$axios(this.api.collection.revdlistApplicantName,{
                status:this.searchForm.status,
            },'post').then(data => {
                if (data && data.status) {
                    this.applicantList = data.data
                }
            })
        },

        handleClick() {
            this.getOthers()
            this.searchForm.applicant = ''
            this.searchForm.status = ''
            this.refreshList(1, 1)
        },

        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val
        },

        // name add新增 view详情 edit编辑
        addData(name, row,index) {
            if (name == 'view'){
                this.detailCurrt = (this.searchForm.current - 1) * this.searchForm.size + index + 1
                this.$refs.detailStore.init(row,'toExamine')
            }
        },

        //type 0通过 1驳回
        examineData(status,row){
            let list = row ? [row] : this.dataListSelections
            if (list.length == 0) {
                this.$message.warning('请至少选择一条数据')
                return
            }
            let ids = list.map(item => {
                return item.id
            })
            let type = status == 0 ? 'through' : 'reject'
            let url = status == 0 ? this.api.collection.collectioninwarehouseBatchSuccess : this.api.collection.collectioninwarehouseBatchReject
            this.$refs.setToexamine.init(ids,type,url)
        },

        //0上一条 1下一条
        itemsChange(type){
            if (type == 0){
                if (this.detailCurrt == 1){
                    this.$message.info('已是第一条')
                    return
                }else {
                    this.detailCurrt --
                }
            }else {
                if (this.detailCurrt == this.total){
                    this.$message.info('已是最后一条')
                    return
                }else {
                    this.detailCurrt ++
                }
            }
            this.$axios(this.api.collection.collectioninwarehouseRevdlist, {
                ...this.searchData,
                current:this.detailCurrt,
                size:1,
            }).then(data => {
                if (data && data.status) {
                    this.$refs.detailStore.init(data.data.records[0])
                } else {
                    this.$message.error('查询失败')
                }
            })
            // this.$emit('itemsChange',type)
        },
    },
}
</script>

<style scoped>
.tips {
    padding: 4px;

    .el-icon-info {
        margin-right: 6px;
    }
}
</style>